import _capitalize from "lodash/capitalize";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import classnames from 'classnames';
import styles from "./Grid.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var Grid = function Grid(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'stretch' : _ref$align,
    _ref$columnsCount = _ref.columnsCount,
    columnsCount = _ref$columnsCount === void 0 ? 3 : _ref$columnsCount,
    _ref$columnsOrder = _ref.columnsOrder,
    columnsOrder = _ref$columnsOrder === void 0 ? [] : _ref$columnsOrder,
    _ref$columnsReverse = _ref.columnsReverse,
    columnsReverse = _ref$columnsReverse === void 0 ? false : _ref$columnsReverse,
    _ref$columnsSize = _ref.columnsSize,
    columnsSize = _ref$columnsSize === void 0 ? [] : _ref$columnsSize,
    children = _ref.children,
    _ref$gridColumns = _ref.gridColumns,
    gridColumns = _ref$gridColumns === void 0 ? 12 : _ref$gridColumns,
    _ref$gutter = _ref.gutter,
    gutter = _ref$gutter === void 0 ? '2.5vw' : _ref$gutter,
    _ref$justify = _ref.justify,
    justify = _ref$justify === void 0 ? 'start' : _ref$justify,
    _ref$removeContainerG = _ref.removeContainerGutter,
    removeContainerGutter = _ref$removeContainerG === void 0 ? false : _ref$removeContainerG,
    _ref$rowGutter = _ref.rowGutter,
    rowGutter = _ref$rowGutter === void 0 ? '0' : _ref$rowGutter;
  // Makes array of children even if only one child, .filter() expects an array.
  var childrenArray = React.Children.toArray(children);
  // Allow to pass null elements to the grid and have conditions columns.
  var childrenNotNull = childrenArray.filter(function (item) {
    return item !== null;
  });
  var content = React.Children.map(childrenNotNull, function (columnCurrent, index) {
    var column = columnCurrent;
    var columnWidth = "".concat(100 / columnsCount, "%");
    if (columnsSize.length && columnsSize[0]) {
      var columnIndex = index % columnsSize.length;
      columnWidth = "".concat(columnsSize[columnIndex] * 100 / gridColumns, "%");
    }
    var columnPosition = 0;
    if (columnsOrder.length && columnsOrder[0]) {
      columnPosition = columnsOrder[index % columnsOrder.length];
    }
    return /*#__PURE__*/_jsx("div", {
      className: classnames(styles.column, column.props.wrapperClassName),
      style: {
        marginBottom: rowGutter,
        order: columnPosition,
        padding: "0 calc(".concat(gutter, " / 2)"),
        width: columnWidth
      },
      children: /*#__PURE__*/_jsx("div", {
        className: styles.columnInner,
        children: column
      })
    });
  });
  var className = classnames(styles.container, styles["containerAlign".concat(_capitalize(align))], columnsReverse && styles['containerReverse'], styles["containerJustify".concat(_capitalize(justify))]);
  var containerStyle = removeContainerGutter ? {
    marginLeft: "calc(-".concat(gutter, " / 2)"),
    marginRight: "calc(-".concat(gutter, " / 2)")
  } : undefined;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    style: containerStyle,
    children: content
  });
};